import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './navbar';
import SortingVisualizer from './sortingVisualizer';

function App() {

  return (
    <div className="App">
      < Navbar />
      < SortingVisualizer />
    </div>
  );
}

export default App;
